const tblSingle = {
  55: [8.0,23.00, 23.00],
  56: [9.0,24.00,24.00],
  57: [10.0, 25.00, 25.00],
  58: [11.5, 26.00, 26.00],
  59: [12.5, 27.00, 27.00],
  60: [14.0, 28.20, 28.20],
  61: [15.0, 29.30, 29.30],
  62: [16.0, 30.20, 30.20],
  63: [17.0, 31.20, 31.20],
  64: [18.0, 32.30, 32.20],
  65: [19.5, 33.20, 33.20],
  66: [21.0, 34.20, 34.20],
  67: [22.0, 35.00, 35.00],
  68: [23.0, 36.00, 36.00],
  69: [24.5, 37.00, 37.00],
  70: [26.0, 38.00, 38.00],
  71: [27.0, 39.20, 39.20],
  72: [28.0, 40.40, 40.40],
  73: [28.5, 41.60, 41.60],
  74: [29.0, 42.70, 42.70],
  75: [30.0, 44.00, 44.00],
  76: [30.5, 45.00, 45.00],
  77: [31.0, 46.10, 46.10],
  78: [32.0, 47.00, 47.00],
  79: [33.0, 47.60, 47.60],
  80: [34.0, 48.50, 48.50],
  81: [35.0, 49.00, 49.00],
  82: [36.0, 50.00, 50.00],
  83: [37.0, 51.00, 51.00],
  84: [38.0, 52.00, 52.00],
  85: [38.0, 50.50, 50.50]
};

const tblJoint = {
  55: [8.0,23.00, 23.00],
  56: [9.0,24.00,24.00],
  57: [10.0, 25.00, 25.00],
  58: [11.5, 26.00, 26.00],
  59: [12.5, 27.00, 27.00],
  60: [14.0, 28.20, 28.20],
  61: [15.0, 29.30, 29.30],
  62: [16.0, 30.20, 30.20],
  63: [17.0, 31.20, 31.20],
  64: [18.0, 32.30, 32.20],
  65: [19.5, 33.20, 33.20],
  66: [21.0, 34.20, 34.20],
  67: [22.0, 35.00, 35.00],
  68: [23.0, 36.00, 36.00],
  69: [24.5, 37.00, 37.00],
  70: [26.0, 38.00, 38.00],
  71: [27.0, 39.20, 39.20],
  72: [28.0, 40.40, 40.40],
  73: [28.5, 41.60, 41.60],
  74: [29.0, 42.70, 42.70],
  75: [30.0, 44.00, 44.00],
  76: [30.5, 45.00, 45.00],
  77: [31.0, 46.10, 46.10],
  78: [32.0, 47.00, 47.00],
  79: [33.0, 47.60, 47.60],
  80: [34.0, 48.50, 48.50],
  81: [35.0, 49.00, 49.00],
  82: [36.0, 50.00, 50.00],
  83: [37.0, 51.00, 51.00],
  84: [38.0, 52.00, 52.00],
  85: [38.0, 50.50, 50.50]
};

const fallBack  = {
  55: [10.0, 12.0],
  56: [11.0, 12.0],
  57: [12.5, 12.5]
};
// const isValid = x => (typeof x !== 'undefined' && x !== null && !isNaN(x));

export const getLtvValue = ({ clientAge, isJoint, housePrice, ltvPlan }) => {
  const age = (clientAge > 84) ? 84 : clientAge;
  const tbl = (isJoint) ? tblJoint[age] : tblSingle[age];

  let fallback = null;

  if(age < 58)
  {
    fallback = fallBack[age]
  }

  let HealthyPreCalc = parseInt( housePrice * 0.01 * tbl[0], 10);
  let HealthPreCalcPer = tbl[0];

  if(HealthyPreCalc < 10000)
  {
    HealthyPreCalc = parseInt( housePrice * 0.01 * fallback[0], 10);
    HealthPreCalcPer = fallback[0];
  }

  if(HealthyPreCalc < 10000)
  {
    HealthyPreCalc = parseInt( housePrice * 0.01 * fallback[1], 10);
    HealthPreCalcPer = fallback[1];
  }

  const Healthy = HealthyPreCalc;
  const Mild = parseInt( housePrice * 0.01 * tbl[1], 10);
  const Moderate = parseInt( housePrice * 0.01 * tbl[2], 10);

  const result = { Healthy, Mild, Moderate };
  result.max = result[ ltvPlan || 'Moderate' ];
  result.diff = result.Moderate - result.Healthy;
  result.pct = { Healthy: HealthPreCalcPer, Mild: tbl[1], Moderate: tbl[2] };
  return result;
};



// WEBPACK FOOTER //
// ./src/services/LtvCalc.js